import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'dateFormat',
     
})
export class DateFormatPipe implements PipeTransform {
  transform(value, format: string = 'MM/DD/YYYY'): any {
    if (!value) {
      return '';
    }
    if (moment.isMoment(value)) {
      return value.format(format);
    } else {
      throw new Error(
        'DateFormatPipe expects input of moment object. Use the LocalMomentPipe or UtcMomentPipe first to create a moment object',
      );
    }
  }
}
